<script>
const sidebarMenu = [

  { path: '/home', icon: 'fas fa-table-list', title: 'Мои заказы' },
  {
    path: '/jobs', icon: 'fas fa-landmark', title: 'Биржа заданий', children: [
      { path: '/jobs/all', title: 'Новые', badge: "2332" },
      { path: '/jobs/PROGRESS', title: 'В процессе ', badge: "10" },
      { path: '/jobs/REVIEW', title: 'На проверке', badge: "21" },
      { path: '/jobs/DECLINED', title: 'Доработать', badge: "2" },
      { path: '/jobs/ACCEPTED', title: 'Завершенные', badge: "456" },
      { path: '/jobs/REJECTED', title: 'Отказано', badge: "3" },
      { path: '/jobs/CANCELED', title: 'Невыполненные', badge: "0" },
      { path: '/jobs/ARBITRAGE', title: 'Арбитраж', badge: "0" },
    ]
  },
  //  { path: '/referral', icon: 'fas fa-user-plus', title: 'Рефералы' },
  //{ path: '/profile', icon: 'fas  fa-user-gear', title: 'Профайл' },
  //  { path: '/help', icon: 'fas  fa-info', title: 'Помощь' },
  { path: '/logout', icon: 'fas fa-sign-out-alt ', title: 'Выйти' },


]

export default sidebarMenu;
</script>
